export const getGrid = (length) => {
  const grid = [];
  for (let i = 0; i < length; i++) {
    grid.push(i);
  }
  return grid;
};
